import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import dealerListingUserPermissionDefinition from "./dealer-listing-user-permission";

const useDealerListingUserPermissions = () => {
  return useUserPermissions(dealerListingUserPermissionDefinition);
};

export default useDealerListingUserPermissions;
